const apiUrl = process.env.API_URL
const conditions = [
  {
    label: '新品',
    value: '新品',
    fixed_condition: 'n'
  },
  {
    label: '未使用',
    value: '未使用',
    fixed_condition: 's'
  },
  {
    label: '美品',
    value: '美品',
    fixed_condition: 'a'
  },
  {
    label: '良好',
    value: '良好',
    fixed_condition: 'b'
  },
  {
    label: '中古',
    value: '中古',
    fixed_condition: 'c'
  },
  {
    label: '不良',
    value: '不良',
    fixed_condition: 'd'
  },
  {
    label: 'ジャンク',
    value: 'ジャンク',
    fixed_condition: 'j'
  }
]


const businessDomains = [
  {
    'value': 'T',
    'label': '東京',
    'color': 'rgb(214, 39, 40)',
    'region': '江東区東陽町',
    'latLng': [35.676914, 139.814721],
    'guide': 'https://www.takakuureru.com/region/trc.html'
  },
  {
    'value': 'O',
    'label': '大阪',
    'color': 'rgb(148, 103, 189)',
    'region': '吹田市垂水町',
    'latLng': [34.762413, 135.501742],
    'guide': 'https://www.takakuureru.com/region/orc.html'
  },
  {
    'value': 'N',
    'label': '名古屋',
    'color': 'rgb(255, 127, 14)',
    'region': '名古屋市中区栄',
    'latLng': [35.166745, 136.901985],
    'guide': 'https://www.takakuureru.com/region/nrc.html'
  },
  {
    'value': 'Y',
    'label': '横浜',
    'color': 'rgb(44, 160, 44)',
    'region': '横浜市港北区新羽町',
    'latLng': [35.525773, 139.612926],
    'guide': 'https://www.takakuureru.com/region/yrc.html'
  },
  {
    'value': 'F',
    'label': '福岡',
    'color': 'rgb(140, 86, 75)',
    'region': '福岡市南区',
    'latLng': [33.573932, 130.421789],
    'guide': 'https://www.takakuureru.com/region/frc.html'
  },
  {
    'value': 'S',
    'label': '埼玉',
    'color': 'rgb(227, 119, 194)',
    'region': '和光市丸山台',
    'latLng': [35.783677, 139.619209],
    'guide': 'https://www.takakuureru.com/region/src.html'
  },
  {
    'value': 'K',
    'label': '神戸',
    'color': 'rgb(127, 127, 127)',
    'region': '神戸市兵庫区',
    'latLng': [34.674973, 135.162672],
    'guide': 'https://www.takakuureru.com/region/krc.html'
  },
  {
    'value': 'M',
    'label': '仙台',
    'color': 'rgb(188, 189, 34)',
    'region': '仙台市若林区六丁の目',
    'latLng': [38.253158, 140.936867],
    'guide': 'https://www.takakuureru.com/region/serc.html'
  },
  {
    'value': 'W',
    'label': '西東京',
    'color': 'rgb(236, 109, 113)',
    'region': '府中市是政',
    'latLng': [35.659553, 139.479928],
    'guide': 'https://www.takakuureru.com/region/wrc.html'
  },
  {
    'value': 'H',
    'label': '札幌',
    'color': '#f5c500',
    'region': '札幌市北区',
    'latLng': [43.101829, 141.31373],
    'mainCalendar': 'h-staff@marketenterprise.co.jp',
    'guide': 'https://www.takakuureru.com/region/hrc.html'
  }
]

const legalCautionLists = [
  '古物営業法上、本人確認書類に記載の住所に限ります',
  '建物名、部屋番号がある場合は必ずご記入ください'
]
const companyData = [
  {
    corp_name: '株式会社マーケットエンタープライズ',
    corp_name_en: 'MarketEnterprise Co.,Ltd.',
    // 本社住所
    head_office_zip: '〒104-0031',
    head_office_pref: '東京都',
    head_office_address: '中央区京橋3-6-18',
    head_office_building: '東京建物京橋ビル3F',

    // 公安許可番号
    kouan_numbers: [
      '北海道公安委員会許可 第101280002259号',
      '宮城県公安委員会許可 第221030002515号',
      '埼玉県公安委員会許可 第431040031585号',
      '東京都公安委員会許可 第307730608365号',
      '神奈川県公安委員会許可 第451450015098号',
      '愛知県公安委員会許可 第541161210200号',
      '大阪府公安委員会許可 第622030123963号',
      '兵庫県公安委員会許可 第631141500030号',
      '福岡県公安委員会許可 第901071410024号'
    ],
    // 著作権表示
    copyright: 'Copyright © MarketEnterprise Co.,Ltd. All Rights Reserved.'
  }
]

export default {
  apiUrl,
  legalCautionLists,
  businessDomains,
  companyData
}



// WEBPACK FOOTER //
// ./src/settings.js